import { ReebeloStoreT } from '@lambda/reebelo';

export const storeDetails: Partial<Record<ReebeloStoreT, string[]>> & {
  default: string[];
} = {
  'reebelo-us': [
    'Complete Accidental Damage & Breakdown Cover inc. Liquid Spills',
    'Access to >1,000 Retail Locations for on-demand repair',
    '24/7 Support',
  ],
  'reebelo-au': [
    'Product servicing or replacement, for any reason.',
    'Includes support for damage, liquid spills, and faulty parts.',
    'Unlimited servicing or 1x replacement from only $69 per claim (<a href="https://edge.reebelo.com/files/sqt/01-PDS.pdf" class="text-blue-500 underline" target="_blank" rel="noopener noreferrer">Terms apply</a>).',
    '24/7 online self-service available or call us in AU business hours.',
  ],
  quista: [
    'Worldwide Protection Against Physical & Liquid Damage',
    'Screen and Battery Replacement Included',
    '24-Months Extended Warranty',
    'Hassle Free: Mail-in or Walk-in Repair Options Nationwide',
  ],
  'reebelo-nz': [
    'Worldwide Protection Against Physical & Liquid Damage',
    'Screen and Battery Replacement Included',
    '24-Months Extended Warranty',
    'Hassle Free: Mail-in or Walk-in Repair Options Nationwide',
  ],
  'reebelo-ca': [
    'Covers accidental damage (inc.drops, spills and battery) plus product breakdowns.',
    'Fast Repairs or Replacements.',
    'Fast and easy service with online claims + over-the-phone support.',
  ],
  default: [
    'Complete Accidental Damage & Breakdown Cover',
    'Access to >1,000 Retail Locations for on-demand repair',
    "Express Replacement service if we can't repair your device",
    '24/7 Support',
  ],
};

export const reebelocareProtectionTitle: Partial<
  Record<ReebeloStoreT, string>
> & {
  default: string;
} = {
  'reebelo-au': '24-Month Extended Warranty & Any Reason Care',
  'reebelo-ca': '24-Months Protection by Allstate',
  default: 'Worldwide Protection for 24-Months',
};
